import { CustomRow } from 'interfaces/utils';
import { toCurrency } from 'utils/currency';

export const distributionRows: CustomRow[] = [
  { field: 'name', label: 'EPS' },
  {
    field: 'percentual',
    label: 'Distribuição',
    getParsedValue: (value) => value + '%',
  },
  { field: 'totalCustomer', label: 'Clientes' },
  { field: 'totalContract', label: 'Contratos' },
  {
    field: 'totalCurrentTotalValue',
    label: 'Valor total',
    getParsedValue: (value) => toCurrency(Number(value)),
  },
];

export const debtsDistributionsRow: { [key: string]: CustomRow } = {
  FINANCE_AMOUNT: {
    field: 'total',
    label: 'Valor total',
    getParsedValue: (value) => toCurrency(Number(value)),
  },
  CUSTOMER_AMOUNT: { field: 'total', label: 'Clientes' },
  CONTRACT_AMOUNT: { field: 'total', label: 'Contratos' },
};

export const getDistributionRowsByDebts = (
  debtType: keyof typeof debtsDistributionsRow,
): CustomRow[] => {
  return [
    { field: 'name', label: 'EPS' },
    {
      field: 'percentual',
      label: 'Distribuição',
      getParsedValue: (value) => value + '%',
    },
    debtsDistributionsRow[debtType],
  ];
};
